import React from "react";
import { ProfileDraw } from "../Icons";
import LeadingText from "../LeadingText";

function ProfileHeader({ companyName, clientID }) {
  return (
    <div
      style={{
        minHeight: "100px"
      }}
      className="w-full flex flex items-center justify-center rounded bg-teal shadow mb-2 px-4"
    >
      <div className="w-1/3 flex flex-col items-start justify-center relative">
        <div
          style={{
            width: "70px",
            height: "70px",
            borderRadius: "50%"
          }}
          className="bg-white flex items-center justify-center"
        >
          <ProfileDraw />
        </div>
      </div>
      <div className="w-2/3 flex flex-col items-start justify-center">
        <div className="py-1">
          <LeadingText textColor="white" textSize="lg" fontWeight="medium">
            {companyName}
          </LeadingText>
        </div>
        <div className="py-1">
          <LeadingText textColor="white" textSize="sm" fontWeight="thin">
            {clientID}
          </LeadingText>
        </div>
      </div>
    </div>
  );
}

export default ProfileHeader;



// WEBPACK FOOTER //
// ./src/ProfileHeader/ProfileHeader.js